import { getTemplatesState } from '@containers/templates/templates.selectors'
import { FetchTemplatesRequest } from '@containers/templates/templates.actions'
import {
  SetDefaultData,
  FetchFixedTemplatesRequest,
  UpdateField,
  UpdateFixedTemplatesRequest,
} from './fixed-templates.actions'
import { getFixedTemplatesState } from './fixed-templates.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Map, List } from 'immutable'
import { debounceTime, Subject, Subscription } from 'rxjs'
import { FixedTemplate } from './fixed-templates.interface'

@Component({
  selector: 'app-fixed-templates',
  templateUrl: './fixed-templates.component.html',
  styleUrls: ['./fixed-templates.component.css'],
})
export class FixedTemplatesComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []

  public isLoading: boolean
  public userId: number
  private state$: Subscription
  private templatesState$: Subscription
  public fixedTemplates: Array<FixedTemplate>
  public templates: [] = []
  public onTemplatesAutocomplete$ = new Subject<string>()
  public templatesAutocomplete$: Subscription

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.userId = parseInt(this.route.snapshot.paramMap.get('id'), 10)
    this.store.dispatch<any>(new SetDefaultData('settings'))

    this.templatesAutocomplete$ = this.onTemplatesAutocomplete$
      .pipe(debounceTime(500))
      .subscribe((keyword) => {
        if (keyword) {
          this.store.dispatch<any>(
            new FetchTemplatesRequest({
              filters: keyword
                ? {
                    or: [{ field: 'name', value: keyword }],
                  }
                : {},
              pageSize: 20,
            }),
          )
        }
      })

    this.state$ = this.store
      .pipe(select(getFixedTemplatesState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        this.fixedTemplates = state.get('data').toJS()
      })

    this.templatesState$ = this.store
      .pipe(select(getTemplatesState))
      .subscribe((state) => {
        this.templates = state.get('data').toJS()
      })

    this.store.dispatch<any>(new FetchFixedTemplatesRequest())
    this.store.dispatch<any>(
      new FetchTemplatesRequest({
        pageSize: 50,
      }),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.templatesState$.unsubscribe()
    this.templatesAutocomplete$.unsubscribe()
  }

  public handleFieldChange(
    e: any,
    name: null | string = null,
    row: number,
  ): void {
    this.store.dispatch(new UpdateField(name, e, `data.${row}`))

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state
          .get('validationErrors')
          .delete(`fixedTemplates.${row}.${name}`),
        '',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      // 'fixedTemplates.*.templateId': 'required',
    }
    const validator = new Validator({ fixedTemplates: data.toJS() }, rules, {
      required: 'The field is required.',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateFixedTemplatesRequest(this.userId, payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
